import { addFieldRow } from '../../fields'
import { bloodPressureField, pulseField, respiratoryRateField, temperatureField } from '../../gyn'
import { FieldMap } from '../../types'

export const laborVitalSignsField: FieldMap = {
  name: 'Vital Signs',
  children: {
    temperature: addFieldRow(temperatureField, { index: 1, flex: 1 }),
    bloodPressure: addFieldRow(bloodPressureField, { index: 1, flex: 1 }),
    pulse: addFieldRow(pulseField, { index: 2, flex: 1 }),
    respiratoryRate: addFieldRow(respiratoryRateField, { index: 2, flex: 1 }),
  },
}
